import { Magnet } from './magnet';
import { throttle } from './utils';

export class Socket
{
    static #socket;
    static #space;

    static broadcast = throttle((id, r, x, y) => {
        this.emit('moveMagnet', { id, r, x, y });
    }, 50);

    static emit (message, payload)
    {
        this.#socket.emit(message, { space: this.#space, ...payload });
    }

    static init ()
    {
        const urlParams = new URLSearchParams(window.location.search);
        const space = urlParams.get('space') || 'public';

        this.#socket = io();
        this.#socket.emit('joinSpace', space);

        this.#socket.on('initialState', (magnetData) => Magnet.init(magnetData));
        this.#socket.on('magnetLifted', (data) => Magnet.move(data.id, data));
        this.#socket.on('magnetMoved', (data) => Magnet.move(data.id, data));

        this.#space = space;
    }

}
